(function ($) {
	$(function () {
		var $box = $('.tabs'),
			$tab2 = $box.find('.tabsContent_2'),
			$topMenuItems = $('.js-navItem');

		$box.each(function() {
			var $wrapTab = $(this),
				$tabs = $wrapTab.find('.tabsList__item'),
				$wrapCont = $wrapTab.find('.tabsBox'),
				$tabsContent = $wrapCont.find('.tabsContent'),
				$navItems =  $wrapCont.find('.tabsNav__item'),
				$boxes = $tabsContent.find('.tabsContent__box');

			$tab2.mCustomScrollbar();
			$wrapCont.on('mousewheel', function(event){
				event.stopPropagation();
			});

			$navItems.on('click', function(e) {
				e.preventDefault();
				var id = $(this).data('id');

				$navItems.removeClass('active');
				$(this).addClass('active');
				$boxes.removeClass('active');
				$tabsContent.find('.tabsContent__box[data-id="'+id+'"]').addClass('active');
			});

			$tabs.on('click', function(e) {
				e.preventDefault();
				var id = $(this).data('id');

				$tabs.removeClass('active');
				$(this).addClass('active');
				$tabsContent.removeClass('active');
				$wrapCont.find('.tabsContent_' + id).addClass('active');

				$topMenuItems.removeClass('active');
				if (+id === 4) $topMenuItems.filter('[data-href="partners"]').addClass('active');
				else $topMenuItems.filter('[data-href="contacts"]').addClass('active');
			});
		});
	});
})(jQuery);